import { Currency } from '@/core/currency/interfaces';

const SRD: Currency = {
    name: 'Surinamese Dollar',
    demonym: 'Surinamese',
    majorSingle: 'Dollar',
    majorPlural: 'Dollars',
    codeNumeric: '968',
    symbol: 'Sr$',
    symbolNative: '$',
    minorSingle: 'Cent',
    minorPlural: 'Cents',
    ISOdigits: 2,
    decimals: 2,
    numToBasic: 100,
    code: 'SRD',
    delimiters: {
        thousands: '.',
        decimal: ','
    }
};

export default SRD;
